module.exports = __webpack_public_path__ + "img/pjb.32994c84.jpg";